<template>
    <div class="page course-column">
        <column-skeleton v-if="loading" style="margin-bottom: 100vh"></column-skeleton>

        <img :src="course.cover_img" class="course-column-banner" />

        <div class="course-column-header">
            <div class="header-title">
                <img class="header-title-column" src="/static/img/course/icon_tag_column.svg" alt="" />
                {{ course.title }}
            </div>
            <div class="header-author">{{ course.course_desc }}</div>
            <div class="header-view">
                <div class="header-time-long">已开课{{ course.current_count }}节 | 共{{ course.course_count }}节</div>
                <div class="header-view-count">
                    <div class="header-view-count-text">{{ course.view_count }}人学习</div>
                    <div class="header-view-count-images">
                        <img v-if="course.last_study_user_avatar.length > 2" :src="item" alt="" v-for="(item, index) in course.last_study_user_avatar" :key="index" />
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div class="course-column-content">
            <van-tabs title-class="course-column-content-tab" :swipeable="true" :sticky="true" animated :border="true" :background="'#Fff'">
                <van-tab :title="'目录'">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                        <van-cell v-for="(item,index) in list" :key="item.id" @click="go_detail(item)" :border="false">
                            <div class="course-column-content-left">{{index+1 < 10 ? '0'+(index+1) : index+1}}</div>
                            <div class="course-column-content-right">
                                <div class="course-column-content-right-title">{{item.title}}</div>
                                <div class="course-column-content-right-detail">
                                    {{item.duration_format == "" ? "" : item.duration_format+"/"}}{{item.view_count}}人学习 {{item.progress}}
                                    <img class="float-right" src="/static/img/course/icon_course_list_play.svg" alt="">
                                </div>
                            </div>
                        </van-cell>
                    </van-list>
                </van-tab>
                <van-tab :title="'介绍'" v-if="course.content !== '<p><br></p>'" class="course-column-intro">
                    <div v-html="course.content"></div>
                </van-tab>
                <van-tab v-else :title="''" disabled />
            </van-tabs>
        </div>

<!--        <div class="course-column-content">
            <van-tabs title-class="course-column-content-tab" :swipeable="true" :sticky="true" animated :border="true" :background="'#Fff'">
                <van-tab :title="'目录'" v-if="course.content !== '<p><br></p>'">
                    <div v-html="course.content"></div>
                </van-tab>
                <van-tab v-else :title="'目录'" disabled />

                <van-tab :title="'直播目录'" class="course-column-intro">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                        <div class="course-column-content-preview">
                            <div class="course-column-content-preview-title">直播中·预告</div>
                            <div class="course-column-content-preview-box">
                                <livePreview v-for="(item, index) in previewList" :key="index" :dataItem="item" />
                            </div>
                        </div>

                        <div class="course-column-content-playback">
                            <div class="course-column-content-playback-title">往期回放</div>
                            <div class="course-column-content-playback-box">
                                <livePlayBack v-for="(item, index) in playbackList" :key="index" :dataItem="item" />
                            </div>
                        </div>
                    </van-list>
                </van-tab>
                &lt;!&ndash; <van-tab :title="'相关推荐'" class="course-column-intro">
                    <div v-html="course.content"></div>
                </van-tab> &ndash;&gt;
            </van-tabs>
        </div>-->

        <div class="course-column-footer">
            <van-grid :column-num="2" direction="horizontal">
                <van-grid-item @click="favorite()" v-if="course.isFavorite" icon="/static/img/course/icon_course_favorite_on_24.svg" text="已收藏" />
                <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_24.svg" text="收藏" />
                <van-grid-item @click="openShareData()" icon="/static/img/course/icon_course_share_24.svg" text="分享" />
            </van-grid>
            <van-number-keyboard safe-area-inset-bottom />
        </div>

        <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
            <img class="share-top-img" src="/static/img/pic_course_share_text.svg" alt="" />
            <div class="share-img">
                <img :src="htmlUrl" style="width: 100%" v-if="htmlUrl != ''" alt="" />
            </div>
            <div class="share-cancel-btn" @click="showShareDialog = false">
                <img src="/static/img/course/icon_course_share_close.svg" alt="" />
            </div>
        </van-dialog>

        <Back></Back>
    </div>
</template>

<script>
import Back from '../components/back.vue'
import Interface from '@/util/interface'
import columnSkeleton from '@/skeleton/columnSkeleton'
import livePlayBack from '../components/live-playback.vue'
import livePreview from '../components/live-preview.vue'

export default {
    name: 'course-column',
    components: {
        'column-skeleton': columnSkeleton,
        livePlayBack,
        livePreview,
        Back
    },
    data() {
        return {
            previewList: [
                {
                    content_type: 0,
                    cover_img: 'https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20221110/52a541dce36456581f988306c82734c4_20221110105336.jpg',
                    cover_img_s:
                        'https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20221110/9175d692f23a28c1aab6a94300edbdc5_20221110105404.jpg',
                    current_count: 1,
                    duration: 0,
                    duration_format: '',
                    id: 4,
                    isAppointment: false,
                    live_status: 1,
                    origin_id: 735,
                    origin_type: 4,
                    start_at: '2022-12-03 08:30:00',
                    title: '儿童淋巴瘤协作组第十三期培训暨学术会议',
                    total_count: 1,
                    video_id: '',
                    view_count: 131
                },
                {
                    content_type: 0,
                    cover_img: 'https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20221027/58d52a31a5ff75ff6b335978c615df7c_20221027180013.jpg',
                    cover_img_s: '',
                    current_count: 0,
                    duration: 0,
                    duration_format: '',
                    id: 2,
                    isAppointment: false,
                    live_status: 0,
                    origin_id: 728,
                    origin_type: 4,
                    start_at: '2022-11-22 19:30:00',
                    title: '言方荣教授 | 临床试验中的多重性问题',
                    total_count: 0,
                    video_id: '',
                    view_count: 425
                },
                {
                    content_type: 0,
                    cover_img: 'https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20221027/58d52a31a5ff75ff6b335978c615df7c_20221027180013.jpg',
                    cover_img_s: '',
                    current_count: 0,
                    duration: 0,
                    duration_format: '',
                    id: 2,
                    isAppointment: true,
                    live_status: 0,
                    origin_id: 728,
                    origin_type: 4,
                    start_at: '2022-11-22 19:30:00',
                    title: '言方荣教授 | 临床试验中的多重性问题',
                    total_count: 0,
                    video_id: '',
                    view_count: 425
                }
            ],
            playbackList: [
                {
                    content_type: 0,
                    cover_img: 'https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20221027/58d52a31a5ff75ff6b335978c615df7c_20221027180013.jpg',
                    cover_img_s: '',
                    current_count: 0,
                    duration: 0,
                    duration_format: '02:51:32',
                    id: 2123,
                    isAppointment: false,
                    live_status: 5,
                    origin_id: 728,
                    origin_type: 4,
                    start_at: '2022-11-22 19:30:00',
                    title: '言方荣教授 | 临床试验中的多重性问题',
                    total_count: 0,
                    video_id: '',
                    view_count: 425,
                    type: 3
                },
                {
                    content_type: 0,
                    cover_img: 'https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20221027/58d52a31a5ff75ff6b335978c615df7c_20221027180013.jpg',
                    cover_img_s: '',
                    current_count: 0,
                    duration: 0,
                    id: 123,
                    isAppointment: false,
                    live_status: 5,
                    origin_id: 728,
                    duration_format: '02:51:32',
                    origin_type: 4,
                    start_at: '2022-11-22 19:30:00',
                    title: '言方荣教授 | 临床试验中的多重性问题',
                    total_count: 0,
                    video_id: '',
                    view_count: 425,
                    type: 3
                },
                {
                    content_type: 0,
                    cover_img: 'https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20221027/58d52a31a5ff75ff6b335978c615df7c_20221027180013.jpg',
                    cover_img_s: '',
                    current_count: 0,
                    duration: 0,
                    duration_format: '02:51:32',
                    id: 121,
                    isAppointment: false,
                    live_status: 5,
                    origin_id: 728,
                    origin_type: 4,
                    start_at: '2022-11-22 19:30:00',
                    title: '言方荣教授 | 临床试验中的多重性问题',
                    total_count: 0,
                    video_id: '',
                    view_count: 425,
                    type: 3
                }
            ],
            value: '',
            active: '',
            list: [],
            loading: true,
            finished: true,
            course: {},
            share_data: {},
            showShareDialog: false,
            htmlUrl: '',
            isShow: false,
            status: '',
            page: {
                page: 1,
                pageSize: 10
            }
        }
    },
    methods: {
        onLoad() {},

        fetch(scene) {
            if (scene === 'course') {
                Interface.getData('get', Interface.course.column.detail + '/' + this.id).then(res => {
                    this.course = res.data
                    this.list = res.data.items
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                    if (this.course) {
                        Interface.getShareInfo(this, this.course.title, this.course.cover_img, this.course.course_desc, 1)
                        Interface.mFootPrint(this.id,1,0,'',0,this.course.title)
                    }
                })
            } else if (scene === 'share') {
                let params = {
                    content_id: this.id,
                    type: 1
                }
                Interface.getData('get', Interface.share, params).then(res => {
                    this.htmlUrl = res.data.post_img_url
                })
            }
        },
        favorite() {
            Interface.getData('get', Interface.course.favorite + this.id).then(res => {
                if (res.code == 0) {
                    this.course.isFavorite = !this.course.isFavorite
                }
            })
        },
        go_detail(item) {
            this.$router.push({ name: 'course-detail', params: { id: item.id } })
        },
        onClickIcon() {},
        onClickButton() {},
        openShareData() {
            this.showShareDialog = true
        }
    },
    created() {
        this.id = this.$route.params.id
        this.fetch('course')
        this.fetch('share')
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/course/column/index.vue